import { ajaxSend } from '../../../api/api';

import { PresenceV2Response } from './types';

const base = '/v1/presence';
const baseV2 = '/v2/presence';

export function presenceGetall() {
  return ajaxSend({
    path: base,
  });
}

export function presenceGet(payload: { user_id: string }) {
  const { user_id } = payload;
  return ajaxSend({
    path: `${base}/${user_id}`,
  });
}

export function presenceGetV2(payload: {
  user_id: string;
}): Promise<PresenceV2Response> {
  const { user_id } = payload;
  return ajaxSend({
    path: `${baseV2}/${user_id}`,
  });
}

export function changeSimultaneousRing(payload: string) {
  return ajaxSend({
    method: 'PUT',
    path: `${base}/simultaneous_ring`,
    data: {
      enabled: payload,
    },
  });
}

export function changeSimultaneousRinging(payload: any) {
  const { userId, enabled } = payload;
  return ajaxSend({
    path: `${base}/simultaneous_ring/${userId}`,
    method: 'PUT',
    data: {
      enabled: enabled,
    },
  });
}

export function changeStatus(payload: string) {
  return ajaxSend({
    method: 'PUT',
    path: `${base}`,
    data: {
      presence: payload,
    },
  });
}

export function changeMediaChannel(payload: any) {
  const { working, channel } = payload;
  return ajaxSend({
    method: 'PUT',
    path: `${base}/channel`,
    data: {
      channel: channel,
      working: working,
    },
  });
}

export function changeMedia(payload: any) {
  const { working, media } = payload;
  return ajaxSend({
    method: 'PUT',
    path: `${base}/media`,
    data: {
      media: media,
      working: working,
    },
  });
}
